import { render, staticRenderFns } from "./BButton.vue?vue&type=template&id=4057625c"
import script from "./BButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./BButton.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports